import type { UserDetailUpsertPayload } from "../types/userDetail.types";

const STORAGE_KEY = "pending_user_detail_upsert_v1";

export function setPendingUserDetail(payload: UserDetailUpsertPayload) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

export function getPendingUserDetail(): UserDetailUpsertPayload | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as UserDetailUpsertPayload;
  } catch {
    return null;
  }
}

export function clearPendingUserDetail() {
  localStorage.removeItem(STORAGE_KEY);
}

function extractPrefixAndPhone(raw: string): { prefix_phone: string; phone: string } {
  const trimmed = raw.trim();

  // Format: +57 3001234567
  const m = trimmed.match(/^\s*(\+\d{1,3})\s*(.*)$/);
  if (m) {
    const prefix_phone = m[1];
    const phone = (m[2] ?? "").replace(/\D/g, "");
    return { prefix_phone, phone };
  }

  return { prefix_phone: "+57", phone: trimmed.replace(/\D/g, "") };
}

export function buildPendingUserDetailFromForm(params: {
  fullName: string;
  phoneNumber: string;
}): UserDetailUpsertPayload {
  const fullName = params.fullName.trim().replace(/\s+/g, " ");
  const [first = "", ...rest] = fullName.split(" ");
  const last = rest.join(" ").trim();

  const { prefix_phone, phone } = extractPrefixAndPhone(params.phoneNumber);

  return {
    name: first,
    last_name: last || "-",
    phone,
    prefix_phone,
  };
}


